import { Component, OnInit } from '@angular/core';
import {ConfService} from '../../../conf.service';
import {SignupComponent} from '../../../signup/signup.component';
import {Router} from '@angular/router';
import {LeftpanelComponent} from '../../../leftpanel/leftpanel.component';
import {EnvironmentManagerComponent} from '../../environment-manager/environment-manager.component';
import {AccountInfoService} from '../../../user/account-info.service';

@Component({
  selector: 'app-add-environment',
  templateUrl: './add-environment.component.html',
  styleUrls: ['./add-environment.component.scss']
})
export class AddEnvironmentComponent implements OnInit {

  constructor(private confPost: ConfService,
              public signup: SignupComponent,
              private router: Router,
              public accountInfoService: AccountInfoService,
              public platform: LeftpanelComponent,
              private envManagerComponentInstance: EnvironmentManagerComponent) { }
  data: any;
  environmentPayload: any;
  partner: any;
  adminEnvironmentName: any;
  flag = true;
  data1: any;
  environments: any;
  partnerShortCode: string;
  partnerAccount: string;
  account_password = 'qwerty';
  isDevFromAdmin: boolean;

  ngOnInit() {
      this.isDevFromAdmin = this.platform.isDevEnvironmentFromAdmin;
      const temp = localStorage.getItem('partner').split('-');
      const temp1 = localStorage.getItem('account').split('-');
      if (temp.length > 1) {
          this.partnerShortCode = temp[temp.length - 1];
      } else {
          this.partnerShortCode = localStorage.getItem('partner');
      }
      if (temp1.length > 1) {
          this.partnerAccount = temp1[temp1.length - 1];
      } else {
          this.partnerAccount = localStorage.getItem('partner');
      }

          this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false)
              .subscribe(data1 => {
                  if (data1 && data1['body'] && data1['body'][0]) {
                      this.data1 = data1['body'][0];
                      this.environments = data1['body'][0]['environments'];
                      this.environmentPayload = data1['body'][0]['environments'];
                      // this.environmentPayload = data1[0]['partner_settings']['environment'];
                      this.partner = localStorage.getItem('partner') ;
                      this.adminEnvironmentName = data1['body'][0]['environments'][0]['type'];
                      this.flag = true;
                  } else {
                      alert('Error in retrieving environments. Please try again after sometime');
                  }
              }, error => {

              });
  }
    call(val) {
      this.data1.partner_settings.environment = this.environmentPayload;
        this.confPost.patchEntityData('services', 'services', 'v1', 'settings', this.data1.id, this.data1).subscribe( success =>{
            this.flag = false;
            this.signup.createInfra(val['payload'], this.data1.partner_settings.cloud_infrastructure[0].cloud_provider, val['password']).then(response => {
                this.router.navigate(['environment-settings']);
            });
        });
    }

    createEnvironmentWithAPI(payload) {
      console.log(payload);
    }

    createEnvironment(event, i) {
      this.envManagerComponentInstance.temp[0] = 'admin';
      this.envManagerComponentInstance.partner = this.partnerShortCode;
      this.envManagerComponentInstance.isDirectNavigationWithoutDNSValidation = true;
      this.envManagerComponentInstance.createEnvironment(event, 0).then(response => {
          this.confPost.getSettingsV2CRUD('admin-' + this.partnerShortCode, 'admin-' + this.partnerAccount, false).subscribe(response1 => {
              if (response1 && response1['body'][0]) {
                  this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false).subscribe(response2 => {
                      if (response2 && response2['body'][0]) {
                          response1['body'][0]['environments'].push(response2['body'][0]['environments'][0]);
                          this.confPost.patchEntityData('services', 'services', 'v2', 'settings', response1['body'][0]['id'], response1['body'][0]).subscribe(response3 => {
                              this.platform.openSnackBar('Admin Environment Created Successfully', 'Success', {
                                  duration: 10000,
                                  verticalPosition: 'top',
                                  horizontalPosition: 'center'
                              });
                              this.router.navigateByUrl('/console');
                          }, error => {
                              this.router.navigateByUrl('/console');
                          });
                      }
                  }, error => {
                      this.router.navigateByUrl('/console');
                  });
              }
          }, error => {
              this.router.navigateByUrl('/console');
          });
          // this.platform.openSnackBar('Admin Environment Created Successfully', 'Close', {
          //     duration: 10000,
          //     verticalPosition: 'top',
          //     horizontalPosition: 'center'
          // });
      });
    }

}
